<template>
  <ValidationObserver
    v-if="isShow"
    :ref="`${_uid}-observer`"
    tag="form"
    :data-vv-scope="vvScope"
  >
    <div
      v-for="(field, index) in scaffoldingData.items"
      :key="`${field}${index}`"
      class="q-mb-xs"
    >
      <template v-if="field.fieldName == '{this.root}'">
        <component
          :is="field.type"
          :ref="`${_uid}${field.fieldName ? field.fieldName : ''}${index}`"
          :key="field.inputKey"
          v-model="modelProps"
          :config="field"
          :root-model="rootModel ? rootModel : modelProps"
          :parent="_self"
          :origin-model="originModel ? originModel : undefined"
          v-on="{...$listeners, 'command': command, ...field.events}"
          v-show="!field.hide"
          v-bind="field.restProps"
        />
      </template>
      <template v-else>
        <component
          :is="field.type"
          :ref="`${_uid}${field.fieldName ? field.fieldName : ''}${index}`"
          :key="field.inputKey"
          v-model="modelProps[field.fieldName]"
          :config="field"
          :root-model="rootModel ? rootModel : modelProps"
          :parent="_self"
          :origin-model="originModel ? originModel[field.fieldName] : undefined"
          v-on="{...$listeners, 'command': command, ...field.events}"
          v-show="!field.hide"
          v-bind="field.restProps"
        />
      </template>
    </div>
  </ValidationObserver>
</template>
<script>
import ValidateGlobal from './inputs/ValidateGlobal.js'
export default {
  mixins: [ValidateGlobal],
  model: {
    prop: 'modelProps',
    event: 'inputRoot'
  },
  props: {
    scaffolding: [String, Object],
    modelProps: Object,
    rootModel: Object,
    parent: Object,
    originModel: Object
  },
  data () {
    return {
      scaffoldingData: this.R.clone(this.scaffolding),
      emptyState: [],
      value: this.modelProps,
      valueNotWatch: false,
      vvScope: this.scaffolding && this.scaffolding.vvScope ? this.scaffolding.vvScope : `${this._uid}-observer`,
      isShow: false
    }
  },
  watch: {
    scaffolding: {
      handler: function (newValue) {
        this.scaffoldingData = this.R.clone(newValue)
        if (newValue && !newValue.hasOwnProperty('items')) {
          this.scaffoldingData.items = {}
          for (let key in newValue) {
            this.scaffoldingData.items[key] = this.R.clone(newValue[key])
          }
        }
        this.addVVScope()
      },
      deep: true
    }
  },
  async created () {
    let vm = this
    this.$on('onUpdateScaffolding', (payload) => {
      vm.scaffoldingData = payload
      vm.addVVScope()
    })
    if (typeof this.scaffolding === 'string') {
      this.scaffoldingData = await this.$query(['Scaffolding', this.scaffolding]).then(res => {
        vm.$q.loading.hide()
        return res
      })
    }
    if (this.scaffolding && !this.scaffolding.hasOwnProperty('items')) {
      this.scaffoldingData.items = {}
      for (let key in this.scaffolding) {
        this.scaffoldingData.items[key] = this.R.clone(this.scaffolding[key])
      }
    }
    // Add vee validate scope
    this.addVVScope()
    this.emptyState = this.scaffoldingData ? this.R.times(() => true, Object.keys(this.scaffoldingData.items).length) : []
    this.isShow = true
  },
  methods: {
    async validate () {
      let vm = this
      Object.keys(vm.scaffoldingData.items).forEach(element => {
        try {
          let obj = vm.scaffoldingData.items[element]
          vm.$refs[`${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
        } catch (error) {
          console.log('main', error)
        }
      })
      await vm.$refs[`${vm._uid}-observer`].validate()
      let errInScope = vm.errors.items.filter(item => item.scope === vm.vvScope)
      return vm.R.isEmpty(errInScope)
    },
    command (payload) {
      let vm = this
      switch (payload.cmd) {
        case 'submit-data':
          vm.$emit('submit-data')
          break
        case 'empty-data':
          this.checkEmptyData(payload.config)
          break
        case 'fetch-data':
          this.$emit('fetch-data')
          break
        case 'notify-subriber':
          this.notifySubriber(payload.payload)
          break
        default:
          break
      }
    },
    checkEmptyData (config) {
      if (config && this.scaffoldingData) {
        let finded = this._.findKey(this.scaffoldingData.items, config)
        if (finded) {
          this.emptyState[finded[finded.length - 1] - 1] = this._.isEmpty(this.value[config.fieldName])
        }
      }
      if (this._.every(this.emptyState)) {
        this.$emit('all-fields-empty', this.scaffoldingData)
      }
    },
    addVVScope () {
      if (this.scaffoldingData) {
        for (let key in this.scaffoldingData.items) {
          this.scaffoldingData.items[key].vvScope = this.vvScope
          // Init data for container
          this.initDataForContainer(this.scaffoldingData.items[key])
        }
      }
    },
    initDataForContainer(item) {
      if(item.type === 'Container' && !this.modelProps[item.fieldName]) {
        this.modelProps[item.fieldName] = {}
        this.originModel[item.fieldName] = {}
      }
    },
    notifySubriber(listSubriber) {
      let vm = this
      for(let key in listSubriber) {
        let currentRef = vm
        for(let key2 in listSubriber[key]) {
          currentRef = this.R.path(['$refs', listSubriber[key][key2], 0], currentRef)
        }
        if(currentRef) currentRef.$emit('notifySubriber')
      }
    }
  }
}
</script>
